import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import WhiteLabelWalletHero from "./WhiteLabelWalletHero";
import Bring from "./Bring";
import WLWsolution from "./WLWsolution";
import CustomBranding from "./CustomBranding";
import Glimpse from "./Glimpse";
import WhyChoose from "../NFT Wallet/WhyChoose";

function WhiteLabelWallet() {
  return (
    <div>
      <Header />
      <WhiteLabelWalletHero />
      <Bring />
      <WLWsolution />
      <CustomBranding />
      <Glimpse />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default WhiteLabelWallet;
